export default function PasswordIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 9C2 7.89543 2.89543 7 4 7L12 7C13.1046 7 14 7.89543 14 9L14 13C14 14.1046 13.1046 15 12 15L4 15C2.89543 15 2 14.1046 2 13L2 9Z"
        fill="#C0C2BE"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4C6 3.44772 6.44772 3 7 3H9C9.55228 3 10 3.44772 10 4V7H12V4C12 2.34315 10.6569 1 9 1H7C5.34315 1 4 2.34315 4 4V7H6V4ZM8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
